<footer class="mt-1 text-center small text-muted py-2" role="contentinfo">
  <p class="mb-0">© {{ currentYear }} UNICAMP — Sistema de Inscrições em Concursos | <a routerLink="/acessibilidade" class="text-muted">Acessibilidade</a></p>
</footer>
